// React
import React from 'react';
// Internal
import CustomTable from 'components/shared/molecules/CustomTable/CustomTable';
// Styles
import './styles.scss';
import HeaderDivider from 'components/shared/atoms/HeaderDivider/HeaderDivider';
import isEmpty from 'lodash/isEmpty';

/**
 * @param {string} props.data - The text to be display in the previous button
 * @param {string} props.headerTitle - The text to be display in the header of the table
 * @param {string} props.className - className to be applied to the component
 */
class OrderTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data ? this.props.data : [],
            total: 0,
            headers: this.setHeaders(),
        };
    }

    componentDidMount() {
        // Initial calculations and formatting of prices
        if (this.props.data) {
            this.setState({
                data: this.formatData(this.props.data),
                total: this.calculateTotal(this.props.data),
                headers: this.setHeaders(),
            });
        }
    }

    componentDidUpdate(prevProps) {
        // Only when the value changes the status update will be triggered
        if ((!prevProps.data && this.props.data)
            || (this.props.data && prevProps.data.length !== this.props.data.length)
            || (this.props.vet !== prevProps.vet)
        ) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                data: this.formatData(this.props.data),
                total: this.calculateTotal(this.props.data),
                headers: this.setHeaders(),
            });
        }
    }

    /**
     * Sets the order table headers based on the props
     * 
     * @returns {Array}
     */
    setHeaders() {
        let initialHeaders = [
            {
                name: 'Item',
                id: 'name',
            },
            localStorage.getItem('service-type-name') !== 'vet supply order' ?
            {
                name: 'Engraving',
                id: 'engravingText',
            } : '',
            {
                name: 'Amount',
                id: 'amount',
            },
        ];

        const vetPricing = this.props.vet.getPricingOption();

        // Only show the unit price column if it the vet's pricing information is not set to "No Price"
        if (this.props.vet && vetPricing.toLowerCase() !== 'no price') {
            initialHeaders.push({
                name: vetPricing,
                id: 'unitPrice',
            });
        }

        return initialHeaders;
    }

    /**
     * Format the booking data for the order table 
     * 
     * @param {Array} arLineItem 
     * @returns {Array}
     */
    formatData(arLineItem) {
        let arFinalLineItemData = [];

        // Loop through each line item
        arLineItem.forEach((objLineItem) => {
            let bHasChildProducts = !isEmpty(objLineItem.childProducts);

            // Don't display the engraving text for the current line item if it has child products
            arFinalLineItemData.push({...objLineItem, engravingText: bHasChildProducts ? null : objLineItem.engravingText });

            // If the line item has child products, push them into the final array
            if (bHasChildProducts) {
                objLineItem.childProducts.forEach(childProduct => {
                    if(childProduct.showInConfirmationEmail) {
                        arFinalLineItemData.push({
                            isChild: true,
                            amount: null,
                            engravingText: childProduct.engravingText,
                            name: childProduct.name,
                            unitPrice: null,
                            showInConfirmation: childProduct.showInConfirmationEmail,
                        });
                    }
                });
            }
        });

        return this.setUnitPriceDisplayFormat(arFinalLineItemData);
    }

    /**
     * Formats the unitPrice to a display text with 2 decimals
     * @param {Object[]} dataInput - The data to be formatted with a key unitPrice
     */
    setUnitPriceDisplayFormat = (dataInput) => {
        if (!dataInput) {
            return null;
        }
        return dataInput.map((item) => {
            // Don't format the unit price for child products
            if (item.isChild) {
                return item;
            }

            const newUnitPrice = (item.unitPrice * item.amount).toLocaleString(
                'en-US',
                { maximumFractionDigits: 2, minimumFractionDigits: 2 }
            );
            item.unitPrice = newUnitPrice;
            return item;
        });
    }

    /**
     * Calculates the total of the data unit price and updates the data to unitPrice to a display format
     * @param {Object[]} dataInput - The data to be formatted with a key unitPrice
     */
    calculateTotal = (data) => {
        if (!data || (data && data.length === 0)) {
            return 0;
        }

        const priceArray = data.map((item) => parseFloat(item.unitPrice) * parseFloat(item.amount));
        return priceArray.reduce((accumulator, currentValue) => {
            const newAccumulator = accumulator + currentValue;
            return newAccumulator;
        });
    }

    render() {
        return (
            <div className={`order-table-container ${this.props.className ? this.props.className : ''}`}>
                <HeaderDivider title={this.props.headerTitle} />
                <CustomTable
                    className="order-table"
                    data={this.state.data}
                    headers={this.state.headers}
                    disableSort={ true }
                />
                <p className="total-label">
                    <span>Total (inc GST)</span>
                    {
                        this.props.vet.getPricingOption() !== 'No price' ? 
                        '$' +
                        this.state.total.toLocaleString(
                        'en-US',
                        { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : null
                    }
                    
                </p>                
            </div>
        );
    }
}

export default OrderTable;
